/** A programmer error in the HUD or a flow screen (bad mount point, presentation drift from content). Fail loud. */
export class HudError extends Error {
  override readonly name = 'HudError'
}
